// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_screen__\\+-keQ .styles_mainContent__zuMwv {
  background-color: #fff; }
  .styles_screen__\\+-keQ .styles_mainContent__zuMwv > div {
    padding: 1rem;
    margin: 1rem 3rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Screen/TripanelScreen/styles.module.scss"],"names":[],"mappings":"AAEA;EAEI,sBAAsB,EAAA;EAF1B;IAIM,aAAa;IACb,iBAAiB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.screen {\n  .mainContent {\n    background-color: #fff;\n    & > div {\n      padding: 1rem;\n      margin: 1rem 3rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `styles_screen__+-keQ`,
	"mainContent": `styles_mainContent__zuMwv`
};
export default ___CSS_LOADER_EXPORT___;
